export default /* glsl */`
`;
